import { workspaceForLocation } from "./workspace";

export function needsTradingAccount(path: string, search = ""): boolean {
  return workspaceForLocation(path, search) === "trading";
}
